/** Reports lug'ati (en) */
export default {
  title: "Reports",
  subtitle: "{{scope}} · {{period}} vs {{prev}}",
  tabs: { recruiters: "Recruiters", sources: "Sources", carriers: "Carriers", branches: "Branches", funnel: "Funnel", retention: "Retention", trends: "Trends", finance: "Finance" },
  scope: { all: "All branches", branch: "Branch" },
  filters: { branch: "Branch", recruiter: "Recruiter", allBranches: "All branches", myBranches: "All my branches", locked: "{{branch}} · locked", allRecruiters: "All recruiters" },
  recruiters: {
    funnel: "Funnel · {{month}}",
    retentionTitle: "Retention of hires",
    retentionSub: "based on approved hires; share still working after N days",
    title: "Recruiters · {{count}}",
    sub: "Numbers come from status history. Hired counts only manager-approved hires.",
    cols: { recruiter: "Recruiter", new: "New", contacted: "Contacted", qualified: "Qualified", submitted: "Submitted", hired: "Hired", conv: "Conv.", retention: "Retention 30/60/90", avgTime: "Avg time to hire", topLoss: "Top loss reason", calls: "Calls" },
    empty: "No recruiters in this scope.",
    pending: "+{{count}} pending",
    total: "Total",
    showing_one: "Showing {{count}} recruiter",
    showing_other: "Showing {{count}} recruiters",
  },
  sources: {
    title: "By source", sub: "which source brings drivers who actually get hired",
    cols: { source: "Source", new: "New", hired: "Hired", conversion: "Conversion" },
    empty: "No drivers in this period.", chart: "New vs hired", new: "New", hired: "Hired",
  },
  carriers: {
    title: "By carrier", sub: "submissions in this period and what came back",
    cols: { carrier: "Carrier", submitted: "Submitted", hired: "Hired", rejected: "Rejected", rate: "Rejection rate", reasons: "Top reasons" },
    empty: "No submissions in this period.",
  },
  branches: { title: "Branches side by side", sub: "Budget columns come from the Budget module" },
  funnel: { title: "Full funnel · {{period}}", sub: "drivers that reached each stage in the period; % = from the previous stage", lossTitle: "Where drivers are lost", lossSub: "reasons for Rejected / Not interested / Quit" },
  retention: {
    card: "{{days}}-day retention",
    stillWorking: "{{retained}} of {{eligible}} hires still working",
    none: "no hires older than {{days}} days yet",
    title: "Retention of hires",
    sub: "approved hires whose start date is older than N days; quit drivers count as lost",
  },
  periodPicker: { kind: "Period type", month: "Month", quarter: "Quarter", year: "Year", range: "Custom dates", from: "From", to: "To", value: "Period" },
  export: { button: "Excel", title: "Download this tab as an Excel file (the same filters and period)" },
  delta: { none: "no comparison", same: "same as before", new: "none before", pp: "{{value}} pp", vs: "Compared with {{period}}" },
  summary: { new: "New drivers", submitted: "Submitted to carriers", hired: "Hired", conversion: "Conversion", timeToHire: "Days to hire", days: "{{n}} days", lost: "Lost" },
  trends: {
    hiresTitle: "New drivers and hires · 12 months",
    hiresSub: "Hires are approved hires; conversion = hires / new drivers of the month",
    series: { new: "New drivers", hired: "Hired", conversion: "Conversion" },
    sourcesTitle: "New drivers by source · 12 months",
    sourcesSub: "Where the drivers come from, month by month",
    otherSources: "Other sources",
    empty: "No new drivers in these months.",
    tableTitle: "Month by month",
    col: { month: "Month", contacted: "Contacted", submitted: "Submitted", lost: "Lost" },
  },
  finance: {
    branchOnly: "Money is counted per branch: the recruiter filter does not change this tab.",
    noFeeAmount_one: "{{count}} hire has no carrier payment amount, so revenue is shown lower than it is.",
    noFeeAmount_other: "{{count}} hires have no carrier payment amount, so revenue is shown lower than it is.",
    expected: "Expected revenue",
    expectedHint: "Carrier payments for the hires approved in this period",
    received: "Money received",
    receivedHint: "Carrier payments that reached the accounts in this period (Budget → Money)",
    cost: "Costs",
    costHint: "Approved expenses, salaries and bonuses (Budget), whole months of the period",
    profit: "Profit",
    profitHint: "Expected revenue minus costs",
    costPerHire: "Cost per hire",
    revenuePerHire: "Revenue per hire",
    hiresN_one: "{{count}} hire",
    hiresN_other: "{{count}} hires",
    chartTitle: "Revenue and costs · 12 months",
    chartSub: "In USD; UZS amounts at the rate of their day",
    series: { expected: "Expected revenue", cost: "Costs", profit: "Profit" },
    carriersTitle: "Carriers",
    carriersSub: "Hires of this period: expected, received and still owed",
    branchesTitle: "Branches",
    branchesSub: "Hires, costs and profit per branch",
    empty: "No hires in this period.",
    col: { carrier: "Carrier", hires: "Hires", expected: "Expected", received: "Received", outstanding: "Still owed", status: "Payments", branch: "Branch", cost: "Costs", profit: "Profit", costPerHire: "Cost per hire" },
    paidN: "{{count}} paid",
    pendingN: "{{count}} waiting",
    notPaidN: "{{count}} not paid",
  },
};
